export default __webpack_public_path__ + "static/media/banner1.ef0232ca.png";